webpackJsonp([1],{

/***/ "/sCY":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.glitch=e()}(this,function(){"use strict";function t(){throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs")}function e(t){if(null===t||void 0===t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}function n(t){function e(){return t}function n(){var t=M({},D);return _||M(t,O),t}function r(){var t=M({},D);return j||M(t,A),t}function i(t){return t}function a(t){return p(c,t)}function s(t){return p(i,t)}function u(t){return d(i)}function f(t){return d(l,t,!0)}function h(t){return d(g,t,!0)}function p(t,e,n){return _=function(){return new Promise(function(r,a){if(n)t(e,r,a);else if(t===i)r(e);else try{r(t(e,r,a))}catch(t){a(t)}})},v()?y():r()}function d(t,e,r){return j=function(n){return new Promise(function(a,o){r?t(n,e,a,o):t===i?a(n):t(n,e).then(a,o)})},v()?y():n()}function v(){return _&&j}function y(){return new Promise(function(e,n){_().then(function(e){return b(e,t)},n).then(function(t){j(t).then(e,n)},n)})}function b(t,e){return new Promise(function(n,r){m(t,e.quality).then(function(n){return w(t,n,e)},r).then(n,r)})}function w(t,e,n){return new Promise(function(r,i){E.addEventListener("message",function(t){t.data&&t.data.base64URL?r(t.data.base64URL):i(t.data&&t.data.err?t.data.err:t)}),E.postMessage({params:n,base64URL:e,imageData:t,imageDataWidth:t.width,imageDataHeight:t.height})})}t=o(t);var _,j,E=new Worker(URL.createObjectURL(new Blob(['function fail(a){self.postMessage({err:a.message||a})}function success(a){self.postMessage({base64URL:a})}var isImageData=function(a){return a&&"number"==typeof a.width&&"number"==typeof a.height&&a.data&&"number"==typeof a.data.length&&"object"==typeof a.data},base64Chars="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",base64Map=base64Chars.split(""),reversedBase64Map$1={};base64Map.forEach(function(a,e){reversedBase64Map$1[a]=e});var maps={base64Map:base64Map,reversedBase64Map:reversedBase64Map$1},reversedBase64Map=maps.reversedBase64Map,base64ToByteArray=function(a){for(var e,s=[],t=23,r=a.length;t<r;t++){var i=reversedBase64Map[a.charAt(t)];switch((t-23)%4){case 1:s.push(e<<2|i>>4);break;case 2:s.push((15&e)<<4|i>>2);break;case 3:s.push((3&e)<<6|i)}e=i}return s},jpgHeaderLength=function(a){for(var e=417,s=0,t=a.length;s<t;s++)if(255===a[s]&&218===a[s+1]){e=s+2;break}return e},glitchByteArray=function(a,e,s,t){for(var r=jpgHeaderLength(a),i=a.length-r-4,p=s/100,n=e/100,h=0;h<t;h++){var g=i/t*h|0,o=g+((i/t*(h+1)|0)-g)*n|0;o>i&&(o=i),a[~~(r+o)]=~~(256*p)}return a},base64Map$1=maps.base64Map,byteArrayToBase64=function(a){for(var e,s,t=["data:image/jpeg;base64,"],r=0,i=a.length;r<i;r++){var p=a[r];switch(e=r%3){case 0:t.push(base64Map$1[p>>2]);break;case 1:t.push(base64Map$1[(3&s)<<4|p>>4]);break;case 2:t.push(base64Map$1[(15&s)<<2|p>>6]),t.push(base64Map$1[63&p])}s=p}return 0===e?(t.push(base64Map$1[(3&s)<<4]),t.push("==")):1===e&&(t.push(base64Map$1[(15&s)<<2]),t.push("=")),t.join("")},glitchImageData=function(a,e,s){if(isImageData(a)){var t=base64ToByteArray(e),r=glitchByteArray(t,s.seed,s.amount,s.iterations);return byteArrayToBase64(r)}throw new Error("glitchImageData: imageData seems to be corrupt.")};onmessage=function(a){var e=a.data.imageData,s=a.data.params,t=a.data.base64URL;if(e&&t&&s)try{void 0===e.width&&"number"==typeof a.data.imageDataWidth&&(e.width=a.data.imageDataWidth),void 0===e.height&&"number"==typeof a.data.imageDataHeight&&(e.height=a.data.imageDataHeight),success(glitchImageData(e,t,s))}catch(a){fail(a)}else fail(a.data.imageData?"Parameters are missing.":"ImageData is missing.");self.close()};'],{type:"text/javascript"}))),D={getParams:e,getInput:n,getOutput:r},O={fromImageData:s,fromImage:a},A={toImage:f,toDataURL:u,toImageData:h};return n()}var r=function(t,e,n){return t<e?e:t>n?n:t},i=function(t){var e=!1;if(void 0!==t)try{e=JSON.parse(JSON.stringify(t))}catch(t){}return e},a={amount:35,iterations:20,quality:30,seed:25},o=function(t){return"object"!=typeof(t=i(t))&&(t={}),Object.keys(a).filter(function(t){return"iterations"!==t}).forEach(function(e){"number"!=typeof t[e]||isNaN(t[e])?t[e]=a[e]:t[e]=r(t[e],0,100),t[e]=Math.round(t[e])}),("number"!=typeof t.iterations||isNaN(t.iterations)||t.iterations<=0)&&(t.iterations=a.iterations),t.iterations=Math.round(t.iterations),t},s=function(t,e){void 0===t&&(t=300),void 0===e&&(e=150),this.canvasEl=document.createElement("canvas"),this.canvasEl.width=t,this.canvasEl.height=e,this.ctx=this.canvasEl.getContext("2d")},u={width:{},height:{}};s.prototype.getContext=function(){return this.ctx},s.prototype.toDataURL=function(t,e,n){if("function"!=typeof n)return this.canvasEl.toDataURL(t,e);n(this.canvasEl.toDataURL(t,e))},u.width.get=function(){return this.canvasEl.width},u.width.set=function(t){this.canvasEl.width=t},u.height.get=function(){return this.canvasEl.height},u.height.set=function(t){this.canvasEl.height=t},Object.defineProperties(s.prototype,u);var c=function(t){if(t instanceof HTMLImageElement){if(!t.naturalWidth||!t.naturalHeight||!1===t.complete)throw new Error("This this image hasn't finished loading: "+t.src);var e=new s(t.naturalWidth,t.naturalHeight),n=e.getContext("2d");n.drawImage(t,0,0,e.width,e.height);var r=n.getImageData(0,0,e.width,e.height);return r.data&&r.data.length&&(void 0===r.width&&(r.width=t.naturalWidth),void 0===r.height&&(r.height=t.naturalHeight)),r}throw new Error("This object does not seem to be an image.")},f=s.Image=Image,h=function(t){return new Promise(function(e,n){var r=new f;r.onload=function(){e(r)},r.onerror=function(t){n(t)},r.src=t})},l=function(t,e,n,r){h(t).then(n,r)},p=function(t){return{width:t.width||t.naturalWidth,height:t.height||t.naturalHeight}},d=function(t){var e=p(t),n=new s(e.width,e.height),r=n.getContext("2d");return r.drawImage(t,0,0,e.width,e.height),{canvas:n,ctx:r}},g=function(t,e,n,r){h(t).then(function(t){var e=p(t),r=d(t).ctx.getImageData(0,0,e.width,e.height);r.width||(r.width=e.width),r.height||(r.height=e.height),n(r)},r)},v=function(t){return t&&"number"==typeof t.width&&"number"==typeof t.height&&t.data&&"number"==typeof t.data.length&&"object"==typeof t.data},m=function(t,e){return new Promise(function(n,r){if(v(t)){var i=new s(t.width,t.height);i.getContext("2d").putImageData(t,0,0),n(i.toDataURL("image/jpeg",e/100))}else r(new Error("object is not valid imageData"))})},y={};"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("").forEach(function(t,e){y[t]=e});var b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},w=function(t,e){return e={exports:{}},t(e,e.exports),e.exports}(function(e,n){!function(n,r){e.exports=function(){function e(t){return"function"==typeof t||"object"==typeof t&&null!==t}function n(t){return"function"==typeof t}function r(t){Y=t}function i(t){F=t}function a(){return void 0!==q?function(){q(s)}:o()}function o(){var t=setTimeout;return function(){return t(s,1)}}function s(){for(var t=0;t<$;t+=2)(0,V[t])(V[t+1]),V[t]=void 0,V[t+1]=void 0;$=0}function u(t,e){var n=arguments,r=this,i=new this.constructor(f);void 0===i[Z]&&P(i);var a=r._state;return a?function(){var t=n[a-1];F(function(){return A(a,i,t,r._result)})}():E(r,i,t,e),i}function c(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(f);return y(n,t),n}function f(){}function h(){return new TypeError("You cannot resolve a promise with itself")}function l(){return new TypeError("A promises callback cannot return that same promise.")}function p(t){try{return t.then}catch(t){return rt.error=t,rt}}function d(t,e,n,r){try{t.call(e,n,r)}catch(t){return t}}function g(t,e,n){F(function(t){var r=!1,i=d(n,e,function(n){r||(r=!0,e!==n?y(t,n):_(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&i&&(r=!0,j(t,i))},t)}function v(t,e){e._state===et?_(t,e._result):e._state===nt?j(t,e._result):E(e,void 0,function(e){return y(t,e)},function(e){return j(t,e)})}function m(t,e,r){e.constructor===t.constructor&&r===u&&e.constructor.resolve===c?v(t,e):r===rt?(j(t,rt.error),rt.error=null):void 0===r?_(t,e):n(r)?g(t,e,r):_(t,e)}function y(t,n){t===n?j(t,h()):e(n)?m(t,n,p(n)):_(t,n)}function w(t){t._onerror&&t._onerror(t._result),M(t)}function _(t,e){t._state===tt&&(t._result=e,t._state=et,0!==t._subscribers.length&&F(M,t))}function j(t,e){t._state===tt&&(t._state=nt,t._result=e,F(w,t))}function E(t,e,n,r){var i=t._subscribers,a=i.length;t._onerror=null,i[a]=e,i[a+et]=n,i[a+nt]=r,0===a&&t._state&&F(M,t)}function M(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,i=void 0,a=t._result,o=0;o<e.length;o+=3)r=e[o],i=e[o+n],r?A(n,r,i,a):i(a);t._subscribers.length=0}}function D(){this.error=null}function O(t,e){try{return t(e)}catch(t){return it.error=t,it}}function A(t,e,r,i){var a=n(r),o=void 0,s=void 0,u=void 0,c=void 0;if(a){if(o=O(r,i),o===it?(c=!0,s=o.error,o.error=null):u=!0,e===o)return void j(e,l())}else o=i,u=!0;e._state!==tt||(a&&u?y(e,o):c?j(e,s):t===et?_(e,o):t===nt&&j(e,o))}function x(t,e){try{e(function(e){y(t,e)},function(e){j(t,e)})}catch(e){j(t,e)}}function I(){return at++}function P(t){t[Z]=at++,t._state=void 0,t._result=void 0,t._subscribers=[]}function L(t,e){this._instanceConstructor=t,this.promise=new t(f),this.promise[Z]||P(this.promise),W(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?_(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&_(this.promise,this._result))):j(this.promise,S())}function S(){return new Error("Array Methods must be provided an Array")}function T(t){return new L(this,t).promise}function C(t){var e=this;return new e(W(t)?function(n,r){for(var i=t.length,a=0;a<i;a++)e.resolve(t[a]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function B(t){var e=new this(f);return j(e,t),e}function k(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function U(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function R(t){this[Z]=I(),this._result=this._state=void 0,this._subscribers=[],f!==t&&("function"!=typeof t&&k(),this instanceof R?x(this,t):U())}function H(){var t=void 0;if(void 0!==b)t=b;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;if(e){var n=null;try{n=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===n&&!e.cast)return}t.Promise=R}var N=void 0,W=N=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},$=0,q=void 0,Y=void 0,F=function(t,e){V[$]=t,V[$+1]=e,2===($+=2)&&(Y?Y(s):X())},J="undefined"!=typeof window?window:void 0,K=J||{},z=K.MutationObserver||K.WebKitMutationObserver,G="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Q="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,V=new Array(1e3),X=void 0;X=G?function(){return function(){return process.nextTick(s)}}():z?function(){var t=0,e=new z(s),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}():Q?function(){var t=new MessageChannel;return t.port1.onmessage=s,function(){return t.port2.postMessage(0)}}():void 0===J&&"function"==typeof t?function(){try{var e=t("vertx");return q=e.runOnLoop||e.runOnContext,a()}catch(t){return o()}}():o();var Z=Math.random().toString(36).substring(16),tt=void 0,et=1,nt=2,rt=new D,it=new D,at=0;return L.prototype._enumerate=function(){for(var t=this,e=this.length,n=this._input,r=0;this._state===tt&&r<e;r++)t._eachEntry(n[r],r)},L.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===c){var i=p(t);if(i===u&&t._state!==tt)this._settledAt(t._state,e,t._result);else if("function"!=typeof i)this._remaining--,this._result[e]=t;else if(n===R){var a=new n(f);m(a,t,i),this._willSettleAt(a,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},L.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===tt&&(this._remaining--,t===nt?j(r,n):this._result[e]=n),0===this._remaining&&_(r,this._result)},L.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(et,e,t)},function(t){return n._settledAt(nt,e,t)})},R.all=T,R.race=C,R.resolve=c,R.reject=B,R._setScheduler=r,R._setAsap=i,R._asap=F,R.prototype={constructor:R,then:u,catch:function(t){return this.then(null,t)}},R.polyfill=H,R.Promise=R,R}()}()}),_=Object.getOwnPropertySymbols,j=Object.prototype.hasOwnProperty,E=Object.prototype.propertyIsEnumerable,M=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(t){r[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(t){return!1}}()?Object.assign:function(t,n){for(var r,i,a=arguments,o=e(t),s=1;s<arguments.length;s++){r=Object(a[s]);for(var u in r)j.call(r,u)&&(o[u]=r[u]);if(_){i=_(r);for(var c=0;c<i.length;c++)E.call(r,i[c])&&(o[i[c]]=r[i[c]])}}return o};return console.log("p",w),w.polyfill(),n});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "1spv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/island.685ab59.svg";

/***/ }),

/***/ "4QBO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5q+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  muteAudio: true
};

// getters
var getters = {
  muteAudio: function muteAudio(state) {
    return state.muteAudio;
  }
};

// actions
var actions = {
  //   setBpm({ commit }, { bpm }) {
  //     commit('setBpm', { bpm });
  //     store.dispatch('palettes/updateBpm', { bpm });
  //   }
};

// mutations
var mutations = {
  setMuteState: function setMuteState(state, _ref) {
    var mute = _ref.mute;

    state.muteAudio = mute;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "89Fr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9CVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShipInformation_vue__ = __webpack_require__("xuBy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038516c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShipInformation_vue__ = __webpack_require__("mj6B");
function injectStyle (ssrContext) {
  __webpack_require__("TnXL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-038516c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShipInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038516c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShipInformation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AWe5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzFweCIgaGVpZ2h0PSIzMXB4IiB2aWV3Qm94PSIwIDAgMzEgMzEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjEgKDQ0NDYzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjIuMDMxMjUgMCAwIDIuMDMxMjUgMTMuMjgxMjUgMTUuMTU2MjUgMC4xNTYyNSAyOC4yODEyNSAyLjAzMTI1IDMwLjE1NjI1IDE1LjE1NjI1IDE3LjAzMTI1IDI4LjI4MTI1IDMwLjE1NjI1IDMwLjE1NjI1IDI4LjI4MTI1IDE3LjAzMTI1IDE1LjE1NjI1IDMwLjMxMjUgMi4wMzEyNSAyOC4yODEyNSAwIDE1LjE1NjI1IDEzLjI4MTI1Ij48L3BvbHlnb24+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "B3ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"longerFade"}},[(_vm.showComponent)?_c('div',{staticClass:"introduction"},[_c('canvas',{ref:"canvas"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"},on:{"after-enter":_vm.afterWhiteFade,"enter":_vm.whiteFade}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fadeToWhite),expression:"fadeToWhite"}],staticClass:"white"})])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DuVK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sonar.5890d33.mp3";

/***/ }),

/***/ "E5vI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ships__ = __webpack_require__("XI8+");


var state = {
    currentShip: null
};

// getters
var getters = {
    currentShip: function currentShip(state) {
        return state.currentShip;
    },
    nextShip: function nextShip(state) {
        if (state.currentShip + 1 > __WEBPACK_IMPORTED_MODULE_0__ships__["a" /* default */].length) {
            return 0;
        } else {
            return state.currentShip + 1;
        };
    },
    previousShip: function previousShip(state) {
        if (state.currentShip - 1 < 0) {
            return __WEBPACK_IMPORTED_MODULE_0__ships__["a" /* default */].length;
        } else {
            return state.currentShip - 1;
        };
    },
    currentShipInformation: function currentShipInformation(state) {
        return __WEBPACK_IMPORTED_MODULE_0__ships__["a" /* default */][state.currentShip || 0];
    },
    shipImageLink: function shipImageLink(state) {
        var shipName = void 0;
        if (__WEBPACK_IMPORTED_MODULE_0__ships__["a" /* default */][state.currentShip]) {
            shipName = __WEBPACK_IMPORTED_MODULE_0__ships__["a" /* default */][state.currentShip].name;
        } else {
            shipName = 'USS Saratoga';
        }
        var shipLink = '@/../static/images/polaroids/' + shipName.toLowerCase();
        shipLink = shipLink.split(' ').join('-');
        shipLink += '.png';
        if (shipName === 'YO-160') {
            shipLink = '@/../static/images/polaroids/image-unavailable.png';
        }
        return shipLink;
    }
};

// actions
var actions = {
    //   setBpm({ commit }, { bpm }) {
    //     commit('setBpm', { bpm });
    //     store.dispatch('palettes/updateBpm', { bpm });
    //   }
};

// mutations
var mutations = {
    setCurrentShip: function setCurrentShip(state, _ref) {
        var shipIndex = _ref.shipIndex;

        state.currentShip = shipIndex;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "EcU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryText_vue__ = __webpack_require__("YXAX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16036594_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StoryText_vue__ = __webpack_require__("VrTv");
function injectStyle (ssrContext) {
  __webpack_require__("89Fr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16036594"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16036594_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StoryText_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FMIr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjBweCIgaGVpZ2h0PSI2MHB4IiB2aWV3Qm94PSIwIDAgNjAgNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjEgKDQ0NDYzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjYwIDI1IDYwIDM1IDM1IDM1IDM1IDYwIDI1IDYwIDI1IDM1IDAgMzUgMCAyNSAyNSAyNSAyNSAwIDM1IDAgMzUgMjUiPjwvcG9seWdvbj4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "Hj1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IonB":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "L4at":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sonar.f11a11d.ogg";

/***/ }),

/***/ "LLve":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/explosion-loop.36763a5.mp3";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b77778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("aZMS");
function injectStyle (ssrContext) {
  __webpack_require__("RNFW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b77778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_style_scss__ = __webpack_require__("4QBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_styles_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_retinajs__ = __webpack_require__("jUHI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_retinajs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_retinajs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_retina__ = __webpack_require__("YZOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_retina___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_retina__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch_easyhi__ = __webpack_require__("8ICM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch_easyhi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch_easyhi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("vdRI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_retina___default.a, { retina: __WEBPACK_IMPORTED_MODULE_3_retinajs___default.a });

__WEBPACK_IMPORTED_MODULE_5_vue_touch_easyhi___default.a.config.swipe = {
  direction: 'horizontal'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
  id: 'UA-9347930-11'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch_easyhi___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]
});

// GA
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$ga.page({
  page: '/',
  title: 'Home page',
  location: window.location.href
});

/***/ }),

/***/ "PRji":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a67b35e.svg";

/***/ }),

/***/ "RNFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TOpQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TnXL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VrTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"rjs",rawName:"v-rjs",value:(2),expression:"2"},{name:"touch",rawName:"v-touch:swipeleft",value:(_vm.swipeLeft),expression:"swipeLeft",arg:"swipeleft"}],staticClass:"story-text-background",staticStyle:{"background-image":"url('@/../static/images/backgrounds/operation-crossroads.jpg')"}},[_c('div',{staticClass:"story-text desktop",class:{ hideMobileDrawerOpen: _vm.drawerOpen }},_vm._l((_vm.msg),function(char, idx){return _c('span',{staticClass:"typewriter-char",class:{ display: idx <= 90 },attrs:{"id":(idx + "-char")}},[_vm._v(_vm._s(char))])})),_vm._v(" "),_c('div',{staticClass:"story-text mobile",class:{ hideMobileDrawerOpen: _vm.mobileOpen }},_vm._l((_vm.mobileMsg),function(char, idx){return _c('span',{staticClass:"typewriter-char",class:{ display: idx <= 90 },attrs:{"id":(idx + "-charMobile")}},[_vm._v(_vm._s(char))])})),_vm._v(" "),_c('div',{staticClass:"swipe-graphic",class:{ active: _vm.doneTypingMobile, hideMobileDrawerOpen: _vm.mobileOpen },attrs:{"id":"swipe-graphic"}},[_c('img',{attrs:{"src":"@/../static/images/graphics/swipe-left.svg","alt":"Swipe Left"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WdZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XI8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*eslint-disable*/
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'USS Saratoga',
  latitude: '11.586583',
  longitude: '165.508583',
  type: 'Aircraft Carrier',
  bio: "Launched in 1922 as one the United States’ first dedicated aircraft carriers, the 37,000-ton USS Saratoga survived torpedo attacks and kamikaze strikes to earn eight battle stars during WW2.  Surplus to requirements in the post-war Navy, she was selected to take part in Operation Crossroads after a short stint as a training ship. Surviving the first test with little damage, she was sunk by the BAKER shot; the underwater explosion lifting her out of the water and caving in her sides. She currently sits up right on the bottom of the Atoll.",
  link: "https://en.wikipedia.org/wiki/USS_Saratoga_(CV-3)",
  quote: "At a depth range of 15-50m the Saratoga is the shallowest wreck in Bikini Atoll, with the main penetration on the hangar deck. She rests top up making this a good dive for divers new to wreck diving. Bring camera equipment to capture stunning views of the fully intact flight deck, pilot house, and gun batteries. For experienced divers, less than 10% of the wreck is explored giving lots of opportunity for discovery."
}, {
  name: 'HIJMS Nagato',
  latitude: '11.591351',
  longitude: '165.509429',
  type: 'Super Dreadnought Battleship',
  bio: "A Pacific War veteran, the Nagato survived the Japanese disaster at Midway but did not fire her guns in anger until the battle of Leyte Gulf in 1944. Lightly damaged in the battle, she returned to Japan to be converted in a floating anti-aircraft platform, fending off multiple Allied airstrikes in the closing months of the war.  Handed over to the US at the close of hostilities, her unique design made her the perfect candidate for Crossroads, and she was selected to be one of the target ships for the ABLE test. Lightly damaged by the first test, she was 870 meters from the BAKER test and seemingly rode out the shockwave without difficultly. Closer inspection found her hulk to be too radioactive to board and she slowly sunk to the bottom of the lagoon five days later. Her remains now lie upside down under 33.5 meters of water and were recently named among the top 10 diving wrecks in the world.",
  link: "https://en.wikipedia.org/wiki/Japanese_battleship_Nagato",
  quote: "The former jewel of the Japanese fleet capsized and lies head down in 33.5m. The bridge sits right on the sand. You can experience the massive 16-inch guns and even larger rudders and props. Though initially saturated in radiation from the ABLE and BAKER tests, the wreck is safe to dive for those adventurous to reach her depths.  Even though she is upside down, the Nagato offers plenty of areas for penetration. Being upside down makes navigating the inside disorienting. As with any wreck, make sure you bring a line to mark your way in and out safely."
}, {
  name: 'USS Arkansas BB-33',
  latitude: '11.59152',
  longitude: '165.50736',
  type: 'Dreadnought Battleship',
  bio: "A veteran of the Great War and the Second World War, The USS Arkansas served in both the Atlantic and the Pacific, and holds the rare distinction of being one of the few ships to bombard both the coast of France and the island of Iwo Jima. After helping to repatriate American service people at the end of the war, she was selected for Operation Crossroads. Close to the ABLE detonation, she survived with extensive damage to her upper decks. BAKER was a different story, with the blast crushing her underwater hulls ”as if by a tremendous hammer blow.” She currently lies capsized at the bottom of the lagoon.",
  link: "https://en.wikipedia.org/wiki/USS_Arkansas_(BB-33)",
  quote: "The Arkansas is top down at a depth of 55 meters. A lot of the wreck is buried in the sand, but advanced divers will be able to see exposed props, and warped metal caused by the blast that sunk her."
}, {
  name: 'HIJMS Sakawa',
  latitude: '11.596008',
  longitude: '165.505599',
  type: 'Cruiser',
  bio: "The last of a class of four light cruisers completed for the Imperial Japanese Navy, Sakawa had a relatively quiet war. Destined to accompany the giant battleship Yamato on her fateful suicide attack in 1945, fuel shortages meant that she never left the Japanese home islands. Handed over to the US Navy as war booty, after a short duty transporting Japanese troops home from small islands in the Pacific she was selected for Operation Crossroads. In poor condition and infested with rats, she bore the full brunt of the ABLE detonation, burning fiercely and eventually sinking as US Navy tug tried to tow her ashore. Her wreck currently lies under 50 meters of water, with part of the tow cable still attached.",
  link: "https://en.wikipedia.org/wiki/Japanese_cruiser_Sakawa",
  quote: "A 46-52 meter dive depth with a sandy bottom. One of the few Japanese wrecks, bring your camera to take advantage of the 6-24m visibility. You can record some of the impressive flame damage, and natural corals that show both the beauty of nature and the power of the A-bomb."
}, {
  name: 'USS Carlisle',
  latitude: '11.594568',
  longitude: '165.499355',
  type: 'Attack Transport',
  bio: "Only two years old at the time of Operation Crossroads, the USS Carlisle had an uneventful time in the Second World War, spending most of her short career ferrying personnel and supplies between Hawaii and San Francisco. Sunk in the BAKER test, she currently lies over 50m below the surface of the lagoon with extensive damage to her starboard side.",
  link: "https://en.wikipedia.org/wiki/USS_Carlisle_(APA-69)",
  quote: "This dive offers great views of A-bomb damage. Both sides are visible giving divers sharp contrast views of the heavily damaged starboard and undamaged port. At 52m this dive is for advanced deep divers. As with other deep dives in the Atoll, you will want to be multi-gas certified and experienced. Divers using rebreathers will be greatly benefitted for hauling their gear all the way out to Bikini Atoll. Be sure to bring your camera gear to capture the dames and the schools of jack fish."
}, {
  name: 'USS Gilliam',
  latitude: '11.595335',
  longitude: '165.50193',
  type: 'Attack Transport',
  bio: "Launched in 1944, the USS Gilliam was barely into her career before being selected to take part in the invasion of the Philippines. Going on to serve in three major amphibious operations, she ended the war transporting US army personnel home from service in the South Pacific. Selected for the Bikini nuclear tests, she was the target ship for the ABLE shot and took the full force of the blast. She currently lies on her side at the bottom of the lagoon.",
  link: "https://en.wikipedia.org/wiki/USS_Gilliam_(APA-57)",
  quote: "Resting in 55m of water, the USS Giliam is a great wreck if you want to see the awesome power of the ABLE test. The shattered wreck is scattered all over the bottom of the lagoon."
}, {
  name: 'ARDC-13',
  latitude: '11.598077',
  longitude: '165.510502',
  type: 'Dry dock',
  bio: "A 2800-ton dry dock, ARDC-13 was selected for the Bikini Tests to determine the effects of an atomic bomb on land-based concrete structures. Despite being close to both detonations, she survived remarkably well, although radioactive contamination meant that US Navy sailors could only board her for sixteen minutes per day. She was sunk by explosives almost a month after the tests.",
  link: "https://en.wikipedia.org/wiki/ARDC-13",
  quote: "Advanced divers will see the effects of both ABLE and BAKER tests as fires and pressure waves ripped through the dry dock on both tests. The vessel is largely concrete, and divers will be able to tour this artificial reef now covered in corals and sea fans."
}, {
  name: 'USS Anderson',
  latitude: '11.593033',
  longitude: '165.501941',
  type: 'Destroyer',
  bio: "A Sims-class destroyer named after Rear Admiral Alexander Anderson Jr, a Medal of Honour recipient, the Anderson was one of the few ships to be sunk in ABLE test.  A highly decorated WW2 veteran, the ship fought in most of the major sea battles of the Pacific campaign, including the famous US victories at Midway, Coral Sea and Leyte Gulf.",
  link: "https://en.wikipedia.org/wiki/USS_Anderson_(DD-411)",
  quote: "The USS Anderson sleeps peacefully on her port side in about 50m. Great natural light and sand topography make her one of the most photo worthy wrecks in Bikini. Bringing along the camera will reward divers with photos of intact anti-aircraft guns, torpedo tubes, and a perfect view of her twin props."
}, {
  name: 'USS Pilotfish',
  latitude: '11.592402',
  longitude: '165.509783',
  type: 'Submarine',
  bio: "Named after a species of fish that regularly swim in the company of sharks, the USS Pilotfish was another Second World War veteran.  Launched in 1943, she patrolled the Philippine Sea and spent most of the conflict rescuing downed pilots. Moored only 332 meters from Test BAKER, she sunk immediately; the pressure waves buckling her hull and forcing her sea hatches open. Thought to have been salvaged immediately after the test, recent surveys have confirmed that she still lies on the seabed.",
  link: "https://en.wikipedia.org/wiki/USS_Pilotfish_(SS-386)",
  quote: "Half buried in the sand at 52m, this submarine is a great dive for advanced divers, and has great views of the impact of the A-bomb testing."
}, {
  name: 'USS Apogon',
  latitude: '11.590762',
  longitude: '165.508453',
  type: 'Submarine',
  bio: "Named after a species of large-headed salt water fish found in tropical or subtropical waters, the USS Apogon had a distinguished career during the Second World War. In the company of three other submarines, she attacked shipping around the Japanese home islands, but her raiding career was abruptly ended when her periscope was torn off by a ramming freighter in 1945. Surplus to requirements, she was selected for Operation Crossroads and moored only a few hundred meters from the BAKER shot. She sank almost immediately.",
  link: "https://en.wikipedia.org/wiki/USS_Gilliam_(APA-57)",
  quote: "Lying at 52m depth and in upright position, the Apogon allows advanced divers to capture great views of a WWII submarine. Take a journey to the stern to see a torpedo loaded in its tube, while the rest of the wreck is home to various corals and sea fans, making this a beautiful dive."
}, {
  name: 'USS Lamson',
  latitude: '11.599212',
  longitude: '165.505652',
  type: 'Destroyer',
  bio: "A Mahan-class destroyer named after a US Civil War era naval officer, the USS Lamson had a relatively quiet wartime career until being heavily damaged by a Japanese Kamikaze attack in late 1944. Recently repaired and back in active duty, she was selected to take part in the Bikini Atoll tests and was sunk in ABLE test.",
  link: "https://en.wikipedia.org/wiki/USS_Lamson_(DD-367)",
  quote: "A great dive in clear as clear can be water. The Lamson is entombed at 48m and sits perfectly upright. The intact torpedo tubes, mounted guns, and depth charges make the Lamson wonderfully photographic. The Saratoga might be the most popular because of its size and accessibility, but for me, all the intact hardware makes diving the Lamson right at the top of must see Bikini wrecks."
}, {
  name: 'LSM-60',
  latitude: '11.58988',
  longitude: '165.508716',
  type: 'Assault Boat',
  bio: "Participating in the assault landings at Iwo Jima in 1945, LSM-60 was modified to be the target ship of the BAKER test. Through a hole cut into her cargo deck and hull, a standard Mk.3A atomic bomb nicknamed Helen of Bikini was lowered to a depth of 90ft.  The destination blew LSM-60 apart, and parts of her can be found scattered across the lagoon.",
  link: "https://en.wikipedia.org/wiki/USS_LSM-60",
  quote: "The LSM-60 was placed directly above the BAKER test so not much of the vessel has survived. Adventerous divers can explore the site where she sank in around 52-55m of beautiful South Pacific water. If you have it, bring an underwater metal detector, and enjoy some historical treasure hunting."
}, {
  name: 'YO-160',
  latitude: '11.589553',
  longitude: '165.51116',
  type: 'Barge',
  bio: "One of a small number of concrete barges built by the US Navy to save on steel, YO-160 was designed to move large cargos across the Pacific. Selected for Operation Crossroads due to her unique construction, she was only 475 meters from the BAKER detonation and sunk immediately after her test, her hull fractured by parts of the nearby Arkansas.",
  link: "https://en.wikipedia.org/wiki/Type_B_ship#Concrete_Barge",
  quote: "The concrete barge rests at a depth of about 52m. Not a popular dive, but with up to 80m of visibility advanced divers can still enjoy beautiful water and practice wreck dive techniques."
}]);

/***/ }),

/***/ "Xsbi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shipInformationItem',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('ships', {
    shipInfo: 'currentShipInformation',
    previousShip: 'previousShip',
    shipImageLink: 'shipImageLink',
    currentShip: 'currentShip'
  })),
  methods: {
    swipeLeft: function swipeLeft() {
      this.$emit('navigate', -1);
    },
    swipeRight: function swipeRight() {
      this.$emit('navigate', 1);
    }
  }
});

/***/ }),

/***/ "YXAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'story-text',
  data: function data() {
    return {
      msg: 'In 1946, the US Navy conducted ‘Operation Crossroads’; a series of \nnuclear tests at Bikini Atoll in the sparsely populated \nMarshall Islands. \n\nExploding two bombs, ABLE and BAKER, the aim was to prove that \na modern fleet could withstand atomic attack.\n\n Today, the wrecks still litter the seabed around the island of Bikini;\n a testament to the power of nuclear weapons. \n\nUse the interactive map on the right to explore the aftermath of this unique graveyard of Second World War warships.',
      mobileMsg: 'In 1946, the US Navy conducted ‘Operation Crossroads’; a series of \nnuclear tests at Bikini Atoll in the sparsely populated \nMarshall Islands. \n\nExploding two bombs, ABLE and BAKER, the aim was to prove that \na modern fleet could withstand atomic attack.\n\n Today, the wrecks still litter the seabed around the island of Bikini; a testament \nto the power of nuclear weapons.\n\nSwipe left to use our interactive map to explore the aftermath of a nuclear detonation.',
      currentChar: 90,
      currentCharMobile: 90,
      doneTyping: false,
      doneTypingMobile: false,
      raf: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('ui', ['shouldTypeStoryText', 'drawerOpen', 'mobileOpen'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('ui', ['setDrawerState', 'setMobileState']), {
    typeOut: function typeOut() {
      var _this = this;

      if (this.currentChar >= this.msg.length) {
        this.doneTyping = true;
        return;
      }

      document.getElementById(this.currentChar + '-char').classList.add('display');
      this.currentChar += 1;

      this.timeout = setTimeout(function () {
        _this.raf = requestAnimationFrame(_this.typeOut);
      }, Math.random() * 35 + 15);
    },
    typeOutMobile: function typeOutMobile() {
      var _this2 = this;

      if (this.currentCharMobile >= this.mobileMsg.length) {
        this.doneTypingMobile = true;
        return;
      }

      document.getElementById(this.currentCharMobile + '-charMobile').classList.add('display');
      this.currentCharMobile += 1;

      this.timeout = setTimeout(function () {
        _this2.raf = requestAnimationFrame(_this2.typeOutMobile);
      }, Math.random() * 35 + 15);
    },
    swipeLeft: function swipeLeft() {
      if (this.doneTypingMobile) {
        this.setMobileState({ open: true });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timeout);
  },

  watch: {
    shouldTypeStoryText: function shouldTypeStoryText() {
      var _this3 = this;

      setTimeout(function () {
        _this3.typeOut();
        _this3.typeOutMobile();
      }, 1300);
    }
  }
});

/***/ }),

/***/ "YfpN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Mi4zMyAxNTguMDMiPjxkZWZzPjxzdHlsZT4uXDMzIGM5N2FiYWUtNjU3Mi00M2NlLTlkNjktMWY4ZjlmNjE0ODJle2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NnB4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgMTwvdGl0bGU+PGcgaWQ9ImIzMTA0NzFjLWJiNWYtNDdjMi05MWRiLTg2YTBiZDA3YmMyNiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iNzM5NTA2ODYtYjY1MS00MWJjLThmMzktYTU1ZDJhMGI0ZDRjIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwb2x5bGluZSBjbGFzcz0iM2M5N2FiYWUtNjU3Mi00M2NlLTlkNjktMWY4ZjlmNjE0ODJlIiBwb2ludHM9IjMgMyAzOS4wMSA3OS4wMSAzIDE1NS4wMyIvPjwvZz48L2c+PC9zdmc+"

/***/ }),

/***/ "a5i6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/main-explosion.3c666e7.mp3";

/***/ }),

/***/ "aZMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('story-text'),_vm._v(" "),_c('transition',{attrs:{"name":"offCanvasSlideRight"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.drawerOpen || _vm.mobileOpen),expression:"drawerOpen || mobileOpen"}],staticClass:"main-ui",class:{ active: _vm.drawerOpen }},[_c('navigation'),_vm._v(" "),_c('transition',{attrs:{"name":"offCanvasSlideRight"},on:{"after-leave":_vm.afterDrawerClose}},[_c('ship-information',{directives:[{name:"show",rawName:"v-show",value:(_vm.drawerOpen),expression:"drawerOpen"}]})],1)],1)]),_vm._v(" "),_c('introduction'),_vm._v(" "),_c('div',{class:{ light: _vm.drawerOpen || _vm.mobileOpen, lightDesktop: _vm.drawerOpen },attrs:{"id":"audio-toggle"},on:{"click":_vm.toggleAudio}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.muteAudio),expression:"!muteAudio"}],staticClass:"light on",attrs:{"src":"@/../static/images/graphics/speaker-on-light.svg","alt":"Audio On"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.muteAudio),expression:"!muteAudio"}],staticClass:"dark on",attrs:{"src":"@/../static/images/graphics/speaker-on-dark.svg","alt":"Audio On"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.muteAudio),expression:"muteAudio"}],staticClass:"light off",attrs:{"src":"@/../static/images/graphics/speaker-off-light.svg","alt":"Audio Off"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.muteAudio),expression:"muteAudio"}],staticClass:"dark off",attrs:{"src":"@/../static/images/graphics/speaker-off-dark.svg","alt":"Audio Off"}})]),_vm._v(" "),_c('div',{staticClass:"social",class:{ active: _vm.mobileOpen || _vm.drawerOpen }},[_c('div',{staticClass:"social-element"},[_c('a',{staticClass:"social-link",attrs:{"href":_vm.facebookLink,"target":"_blank","id":"facebook-link"}},[_c('img',{attrs:{"src":"@/../static/images/graphics/facebook.svg","alt":"Share"}})])]),_vm._v(" "),_c('div',{staticClass:"social-element"},[_c('a',{staticClass:"social-link",attrs:{"href":_vm.twitterLink,"target":"_blank","id":"twitter-link"}},[_c('img',{attrs:{"src":"@/../static/images/graphics/twitter.svg","alt":"Share"}})])])]),_vm._v(" "),_c('div',{staticClass:"credits-container",class:{ active: _vm.showCredits }},[_c('div',{staticClass:"overlay",on:{"click":function($event){_vm.toggleCredits()}}}),_vm._v(" "),_c('div',{staticClass:"credits-content"},[_c('img',{staticClass:"close",attrs:{"src":"@/../static/images/graphics/close.svg","alt":"Close"},on:{"click":function($event){_vm.toggleCredits()}}}),_vm._v(" "),_c('p',[_vm._v("Audio Credits:")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"credits-toggle",class:{ light: _vm.drawerOpen || _vm.mobileOpen },attrs:{"id":"credits-toggle"},on:{"click":function($event){_vm.toggleCredits()}}},[_c('img',{staticClass:"info-dark",attrs:{"src":"@/../static/images/graphics/info-dark.svg","alt":"More Information"}}),_vm._v(" "),_c('img',{staticClass:"info-light",attrs:{"src":"@/../static/images/graphics/info-light.svg","alt":"More Information"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"credit"},[_c('a',{attrs:{"href":"https://freesound.org/people/Henrythetrain/","target":"_blank"}},[_vm._v("Henrythetrain")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"credit"},[_c('a',{attrs:{"href":"https://freesound.org/people/CGEffex/","target":"_blank"}},[_vm._v("CGEffex")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"https://creativecommons.org/licenses/by/3.0/","target":"_blank"}},[_vm._v("License")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bVQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ships__ = __webpack_require__("XI8+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var sonarMp3 = __webpack_require__("DuVK");
var sonarOgg = __webpack_require__("L4at");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  data: function data() {
    return {
      ships: __WEBPACK_IMPORTED_MODULE_1__ships__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('ships', ['currentShip']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('audio', ['muteAudio'])),
  mounted: function mounted() {
    // sonar bleep
    this.sonar = new Audio();
    if (this.sonar.canPlayType('audio/mpeg')) {
      this.sonar.src = sonarMp3;
    } else {
      this.sonar.src = sonarOgg;
    }

    this.sonar.volume = 0.3;
    this.sonar.muted = this.muteAudio;
  },
  beforeDestroy: function beforeDestroy() {
    this.sonar.pause();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])('ships', ['setCurrentShip']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])('ui', ['setDrawerState', 'setMobileState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])('audio', ['setMuteState']), {
    navClick: function navClick(shipIndex) {
      this.setCurrentShip({ shipIndex: shipIndex });
      this.setDrawerState({ open: true });
      this.playBleep();
    },
    swipeRight: function swipeRight() {
      this.setMobileState({ open: false });
    },
    playBleep: function playBleep() {
      this.sonar.pause();
      this.sonar.currentTime = 0;
      this.sonar.play();
    }
  }),
  watch: {
    muteAudio: function muteAudio() {
      this.sonar.muted = this.muteAudio;
    }
  }
});

/***/ }),

/***/ "bZnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  shouldTypeStoryText: false,
  drawerOpen: false,
  mobileOpen: false,
  playExplosion: false,
  playSonar: false
};

// getters
var getters = {
  shouldTypeStoryText: function shouldTypeStoryText(state) {
    return state.shouldTypeStoryText;
  },
  drawerOpen: function drawerOpen(state) {
    return state.drawerOpen;
  },
  mobileOpen: function mobileOpen(state) {
    return state.mobileOpen;
  },
  playExplosion: function playExplosion(state) {
    return state.playExplosion;
  },
  playSonar: function playSonar(state) {
    return state.playSonar;
  }
};

// actions
var actions = {
  //   setBpm({ commit }, { bpm }) {
  //     commit('setBpm', { bpm });
  //     store.dispatch('palettes/updateBpm', { bpm });
  //   }
};

// mutations
var mutations = {
  setShouldTypeStoryText: function setShouldTypeStoryText(state, _ref) {
    var shouldType = _ref.shouldType;

    state.shouldTypeStoryText = shouldType;
  },
  setDrawerState: function setDrawerState(state, _ref2) {
    var open = _ref2.open;

    state.drawerOpen = open;
  },
  setMobileState: function setMobileState(state, _ref3) {
    var open = _ref3.open;

    state.mobileOpen = open;
  },
  setExplosion: function setExplosion(state, _ref4) {
    var play = _ref4.play;

    state.playExplosion = play;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "bc5e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/palm-trees.2f9111b.jpg";

/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("bVQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d221b60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("qn0u");
function injectStyle (ssrContext) {
  __webpack_require__("TOpQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d221b60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cawT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Introduction_vue__ = __webpack_require__("qlF4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365d1754_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Introduction_vue__ = __webpack_require__("B3ld");
function injectStyle (ssrContext) {
  __webpack_require__("WdZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-365d1754"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Introduction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365d1754_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Introduction_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShipInformationItem_vue__ = __webpack_require__("Xsbi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a013e77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShipInformationItem_vue__ = __webpack_require__("sD8R");
function injectStyle (ssrContext) {
  __webpack_require__("Hj1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a013e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShipInformationItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a013e77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ShipInformationItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m5+n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/main-explosion.48703d0.ogg";

/***/ }),

/***/ "mPlJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/palm-trees@3x.d21bbbe.jpg";

/***/ }),

/***/ "mj6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ship-information",attrs:{"id":"ship-information"}},[_c('div',{staticClass:"divider"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("vId7"),"alt":"US Forces Stamp","id":"forces-stamp"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("x3xq"),"alt":"US Forces Stamp","id":"classified-stamp"}}),_vm._v(" "),_c('div',{staticClass:"ship-information-overflow-wrapper"},[_c('transition',{attrs:{"name":_vm.transitionName},on:{"after-leave":_vm.afterLeave,"enter":_vm.enter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showShip),expression:"showShip"}],staticClass:"ship-information-item-wrapper"},[_c('div',{staticClass:"ibvf"}),_vm._v(" "),_c('ship-information-item',{on:{"navigate":_vm.swipeNavigateHandler}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"info-nav left",on:{"click":function($event){_vm.changeInfo(0)}}},[_c('img',{attrs:{"src":__webpack_require__("YfpN"),"alt":"Arrow"}})]),_vm._v(" "),_c('div',{staticClass:"info-nav right",on:{"click":function($event){_vm.changeInfo(1)}}},[_c('img',{attrs:{"src":__webpack_require__("YfpN"),"alt":"Arrow"}})]),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":_vm.hideShipInformation}},[_c('img',{attrs:{"src":__webpack_require__("AWe5"),"alt":"Close"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qMuw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/explosion-loop.54fdbdb.ogg";

/***/ }),

/***/ "qlF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intrinsic_scale__ = __webpack_require__("prSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intrinsic_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intrinsic_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_canvas_text_wrapper__ = __webpack_require__("xnA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_canvas_text_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_canvas_text_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_glitch_canvas_browser_with_polyfills_min__ = __webpack_require__("/sCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_glitch_canvas_browser_with_polyfills_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_glitch_canvas_browser_with_polyfills_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webfontloader__ = __webpack_require__("01M/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_webfontloader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var logoImageSource = __webpack_require__("PRji");

var backgrounds = [__webpack_require__("bc5e"), //eslint-disable-line
__webpack_require__("zLeK"), //eslint-disable-line
__webpack_require__("mPlJ")];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'introduction',
  data: function data() {
    return {
      msg: 'In 1946, the US Navy conducted ‘Operation Crossroads’; a series of nuclear tests at Bikini',
      currentChar: 0,
      msgTyped: '',
      context: undefined,
      backgroundImage: undefined,
      logoImage: undefined,
      cacheCanvas: undefined,
      cacheContext: undefined,
      raf: 0,
      textWidth: 0,
      fadeToWhite: false,
      showComponent: true,
      glitchDone: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.cacheCanvas = document.createElement('canvas');
    this.cacheContext = this.cacheCanvas.getContext('2d');

    var canvas = this.$refs.canvas;
    var context = canvas.getContext('2d');
    this.canvas = canvas;
    this.context = context;

    canvas.width = window.innerWidth * window.devicePixelRatio;
    canvas.height = window.innerWidth * window.devicePixelRatio;

    this.cacheCanvas.width = canvas.width / 8;
    this.cacheCanvas.height = canvas.height / 8;

    var bgimage = new Image();
    var imageSource = '/static/images/backgrounds/';

    var dpr = Math.round(window.devicePixelRatio - 1);
    if (isNaN(dpr)) {
      dpr = 0;
    } else if (dpr > 2) {
      dpr = 2;
    }

    imageSource = backgrounds[dpr];

    var bgImagePromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      bgimage.onload = function () {
        resolve(bgimage);
      };
    });

    var logoImage = new Image();

    var logoImagePromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      logoImage.onload = function () {
        resolve(logoImage);
      };
    });

    var webFontPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_6_webfontloader___default.a.load({ // eslint-disable-line
        google: {
          families: ['Open Sans', 'Special Elite']
        },
        active: resolve
      });
    });

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([bgImagePromise, logoImagePromise, webFontPromise]).then(function (datas) {
      _this.backgroundImage = datas[0];
      _this.logoImage = datas[1];
      _this.resize(canvas, context);
      _this.draw().then(_this.typeOut());
    });

    bgimage.src = imageSource;
    logoImage.src = logoImageSource;

    window.addEventListener('resize', this.resize.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize.bind(this));
    this.setExplosion({ play: false });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])('ui', ['setShouldTypeStoryText', 'setExplosion']), {
    typeOut: function typeOut() {
      var _this2 = this;

      if (this.currentChar >= this.msg.length) {
        setTimeout(function () {
          cancelAnimationFrame(_this2.raf);
          _this2.raf = requestAnimationFrame(_this2.loopGlitch);
          setTimeout(function () {
            _this2.fadeToWhite = true;
          }, 225);
        }, 130);
        return;
      }
      this.msgTyped += this.msg[this.currentChar];
      this.currentChar += 1;

      setTimeout(function () {
        _this2.raf = requestAnimationFrame(_this2.typeOut);
      }, Math.random() * 55 + 45);

      this.draw();
      if (this.currentChar > 9 && this.currentChar < 15 || this.currentChar > 40 && this.currentChar < 42 || this.currentChar > 45 && this.currentChar < 49 || this.currentChar > 60 && this.currentChar <= 61) {
        this.drawGlitch();
      }
    },
    loopGlitch: function loopGlitch(delta) {
      var _this3 = this;

      if (Math.round(delta) % 2 === 0) {
        this.drawGlitch().then(function () {
          if (!_this3.glitchDone) _this3.raf = requestAnimationFrame(_this3.loopGlitch);
        });
      } else {
        if (!this.glitchDone) {
          //eslint-disable-line
          this.raf = requestAnimationFrame(this.loopGlitch);
        }
      }
    },
    drawGlitch: function drawGlitch() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var canvas = _this4.canvas,
            context = _this4.context,
            cacheCanvas = _this4.cacheCanvas,
            cacheContext = _this4.cacheContext;

        cacheContext.drawImage(canvas, 0, 0, cacheCanvas.width, cacheCanvas.height);

        __WEBPACK_IMPORTED_MODULE_5__lib_glitch_canvas_browser_with_polyfills_min___default()({ seed: Math.floor(Math.random() * 20) + 10, quality: 99, amount: 0 }).fromImageData(cacheContext.getImageData(0, 0, cacheCanvas.width, cacheCanvas.height)).toImageData().then(function (glitchedImgData) {
          cacheContext.putImageData(glitchedImgData, 0, 0);
          context.drawImage(cacheCanvas, 0, 0, canvas.width, canvas.height);
          resolve();
        }).catch(function () {
          resolve();
        });
      });
    },
    draw: function draw() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var canvas = _this5.canvas,
            context = _this5.context,
            backgroundImage = _this5.backgroundImage,
            logoImage = _this5.logoImage;

        var _cover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_intrinsic_scale__["cover"])(canvas.width, canvas.height, backgroundImage.width, backgroundImage.height),
            width = _cover.width,
            height = _cover.height,
            x = _cover.x,
            y = _cover.y;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(backgroundImage, x, y, width, height);

        var logoAspectRatio = 2.567307692;

        var logoHeight = canvas.height / 100 * 19.25;
        var logoWidth = logoHeight * logoAspectRatio;

        context.drawImage(logoImage, canvas.width / 2 - logoWidth / 2, canvas.height / 100 * 7.04, logoWidth, logoHeight);

        context.fillStyle = '#fff';

        _this5.textSize = 28;
        var actualWidth = canvas.width / window.devicePixelRatio;

        if (actualWidth < 768) {
          _this5.textSize = 20;
        }

        if (actualWidth < 400) {
          _this5.textSize = 18;
        }

        if (actualWidth < 375) {
          _this5.textSize = 18;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_canvas_text_wrapper__["CanvasTextWrapper"])(canvas, _this5.msgTyped, {
          renderHDPI: false,
          font: _this5.textSize * window.devicePixelRatio + 'px "Special Elite", cursive',
          textAlign: 'center',
          paddingY: canvas.height / 100 * 31.111111111,
          paddingX: _this5.textWidth,
          lineHeight: _this5.textSize * (window.devicePixelRatio + 0.8) + 'px'
        });

        resolve();
      });
    },
    resize: function resize() {
      var canvas = this.canvas;


      canvas.width = window.innerWidth * window.devicePixelRatio;
      canvas.height = window.innerHeight * window.devicePixelRatio;

      this.cacheCanvas.width = canvas.width / 8;
      this.cacheCanvas.height = canvas.height / 8;

      this.context.fontStyle = this.textSize * window.devicePixelRatio + 'px "Special Elite", cursive';
      this.textWidth = Math.abs(this.canvas.width / 3 - this.context.measureText(this.msg).width);

      this.draw();
    },
    whiteFade: function whiteFade() {
      this.setShouldTypeStoryText({ shouldType: true });
      this.setExplosion({ play: true });
    },
    afterWhiteFade: function afterWhiteFade() {
      this.glitchDone = true;
      this.showComponent = false;
      cancelAnimationFrame(this.raf);
    }
  })
});

/***/ }),

/***/ "qn0u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:swiperight",value:(_vm.swipeRight),expression:"swipeRight",arg:"swiperight"}],staticClass:"nav-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation-links"},[_c('img',{attrs:{"src":__webpack_require__("1spv"),"id":"island","alt":"Island"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("IonB"),"id":"map-label","alt":"Ocean Label"}}),_vm._v(" "),_vm._l((_vm.ships),function(ship, index){return _c('div',{staticClass:"navigation-link",class:{ 'active': index === _vm.currentShip },on:{"click":function($event){_vm.navClick(index)}}},[_vm._m(1,true),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(ship.name)+"\n        "),_c('span',{staticClass:"ship-location"},[_vm._v("\n          LAT: "+_vm._s(ship.latitude)+",\n          "),_c('br'),_vm._v("\n          LNG: "+_vm._s(ship.longitude)+"\n        ")])])])})],2),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-image"},[_c('img',{attrs:{"src":__webpack_require__("PRji"),"alt":"Bikini Atoll Logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plus"},[_c('div',{staticClass:"sonar"}),_vm._v(" "),_c('div',{staticClass:"plus-background"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("FMIr"),"alt":"Plus Symbol"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale-info"},[_c('p',[_vm._v("*map not to scale")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sD8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:swipeleft",value:(_vm.swipeLeft),expression:"swipeLeft",arg:"swipeleft"},{name:"touch",rawName:"v-touch:swiperight",value:(_vm.swipeRight),expression:"swipeRight",arg:"swiperight"}],staticClass:"ship-information-item content-container",attrs:{"id":"content-wrapper"}},[_c('div',{staticClass:"header-section"},[_c('h3',[_vm._v(_vm._s(_vm.shipInfo.name))]),_vm._v(" "),_c('div',{attrs:{"id":"ship-image"}},[_c('img',{directives:[{name:"rjs",rawName:"v-rjs",value:(2),expression:"2"}],attrs:{"src":_vm.shipImageLink,"alt":"Ship Image"}})]),_vm._v(" "),_c('p',{staticClass:"coordinate-string"},[_c('b',[_vm._v("Latitude")]),_vm._v(": "+_vm._s(_vm.shipInfo.latitude))]),_vm._v(" "),_c('p',{staticClass:"coordinate-string"},[_c('b',[_vm._v("Longitude")]),_vm._v(": "+_vm._s(_vm.shipInfo.longitude))]),_vm._v(" "),_c('p',{staticClass:"ship-type"},[_c('b',[_vm._v("Ship Type")]),_vm._v(": "+_vm._s(_vm.shipInfo.type))])]),_vm._v(" "),_c('div',{staticClass:"bio"},[_c('p',[_vm._v(_vm._s(_vm.shipInfo.bio))])]),_vm._v(" "),_c('div',{staticClass:"quote-container"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"quote"},[_vm._v(_vm._s(_vm.shipInfo.quote))])]),_vm._v(" "),_c('div',{staticClass:"cta-container"},[_c('a',{attrs:{"href":_vm.shipInfo.link,"target":"_blank"}},[_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"quote-title"},[_c('a',{attrs:{"href":"https://www.divein.com/about-divein/","target":"_blank"}},[_vm._v("Torben Lonne, Editor-In-Chief at DIVE.in:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta"},[_c('p',[_vm._v("Find out more >")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vId7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/us-forces-stamp.48d9c76.png";

/***/ }),

/***/ "vdRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_localstorage__ = __webpack_require__("kQU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ships__ = __webpack_require__("E5vI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ui__ = __webpack_require__("bZnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_audio__ = __webpack_require__("5q+B");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';
if (debug) {
  console.warn('Vuex is in STRICT mode as NODE_ENV is set to "' + "production" + '".\n\nAll commits are syncronously watched. Performance lag is due to this.');
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default()({
    namespace: 'bikini-atoll',
    initialState: {
      muteAudio: true
    },
    paths: ['audio'],
    expires: 0 // Never expire
  })],
  modules: {
    ships: __WEBPACK_IMPORTED_MODULE_3__modules_ships__["a" /* default */],
    ui: __WEBPACK_IMPORTED_MODULE_4__modules_ui__["a" /* default */],
    audio: __WEBPACK_IMPORTED_MODULE_5__modules_audio__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "x3xq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/classified.6a5b21e.png";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StoryText__ = __webpack_require__("EcU6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Introduction__ = __webpack_require__("cawT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navigation__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ShipInformation__ = __webpack_require__("9CVr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// active: drawerOpen,






var explosionMp3 = __webpack_require__("a5i6");
var explosionOgg = __webpack_require__("m5+n");
var loopMp3 = __webpack_require__("LLve");
var loopOgg = __webpack_require__("qMuw");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    StoryText: __WEBPACK_IMPORTED_MODULE_2__components_StoryText__["a" /* default */],
    Introduction: __WEBPACK_IMPORTED_MODULE_3__components_Introduction__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_4__components_Navigation__["a" /* default */],
    ShipInformation: __WEBPACK_IMPORTED_MODULE_5__components_ShipInformation__["a" /* default */]
  },
  data: function data() {
    return {
      showCredits: false,
      facebookLink: '',
      twitterLink: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('ui', ['drawerOpen', 'mobileOpen', 'playExplosion']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('audio', ['muteAudio'])),
  mounted: function mounted() {
    // first explosion
    this.explosion = new Audio();
    if (this.explosion.canPlayType('audio/mpeg')) {
      this.explosion.src = explosionMp3;
    } else {
      this.explosion.src = explosionOgg;
    }
    // background loop
    this.backgroundLoop = new Audio();
    if (this.backgroundLoop.canPlayType('audio/mpeg')) {
      this.backgroundLoop.src = loopMp3;
    } else {
      this.backgroundLoop.src = loopOgg;
    }
    this.backgroundLoop.loop = true;

    this.explosion.muted = this.muteAudio;
    this.backgroundLoop.muted = this.muteAudio;

    // social links
    var url = window.location.href;
    this.facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    this.twitterLink = ('http://twitter.com/share?text=Explore the shipwrecks from %23BikiniAtoll\u2019s nuclear bomb tests in 1946 \u2013 it\u2019s the perfect %23scubadiving adventure!&url=' + url).replace(' ', '+');
  },
  beforeDestroy: function beforeDestroy() {
    this.explosion.pause();
    this.backgroundLoop.pause();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('ships', ['setCurrentShip']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('audio', ['setMuteState']), {
    afterDrawerClose: function afterDrawerClose() {
      this.setCurrentShip({ ship: null });
    },
    toggleAudio: function toggleAudio() {
      this.setMuteState({ mute: !this.muteAudio });
    },
    toggleCredits: function toggleCredits() {
      this.showCredits = !this.showCredits;
    }
  }),
  watch: {
    playExplosion: function playExplosion() {
      var _this = this;

      if (this.playExplosion) {
        this.explosion.play();
        setTimeout(function () {
          _this.backgroundLoop.play();
        }, 4000);
      }
    },
    muteAudio: function muteAudio() {
      this.explosion.muted = this.muteAudio;
      this.backgroundLoop.muted = this.muteAudio;
    }
  }
});

/***/ }),

/***/ "xuBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ShipInformationItem__ = __webpack_require__("jlbC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ships__ = __webpack_require__("XI8+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shipInformation',
  data: function data() {
    return {
      showShip: true,
      nextShipNumber: null,
      transitionName: 'shipTransitionRight'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('ships', {
    shipInfo: 'currentShipInformation',
    nextShip: 'nextShip',
    previousShip: 'previousShip',
    shipImageLink: 'shipImageLink',
    currentShip: 'currentShip'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('ships', ['setCurrentShip']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('ui', ['setDrawerState']), {
    changeInfo: function changeInfo(b) {
      var nextShip = void 0;
      if (b) {
        nextShip = this.currentShip + 1;
        if (nextShip > __WEBPACK_IMPORTED_MODULE_3__ships__["a" /* default */].length - 1) {
          nextShip = 0;
        }
        this.goToShip({ shipIndex: nextShip, transitionName: 'shipTransitionLeft' });
      } else {
        nextShip = this.currentShip - 1;
        if (nextShip < 0) {
          nextShip = __WEBPACK_IMPORTED_MODULE_3__ships__["a" /* default */].length - 1;
        }
        this.goToShip({ shipIndex: nextShip, transitionName: 'shipTransitionRight' });
      }
    },
    swipeNavigateHandler: function swipeNavigateHandler(direction) {
      if (direction < 0) {
        this.changeInfo(1);
      } else {
        this.changeInfo(0);
      }
    },
    hideShipInformation: function hideShipInformation() {
      this.setDrawerState({ open: false });
    },
    goToShip: function goToShip(_ref) {
      var shipIndex = _ref.shipIndex,
          transitionName = _ref.transitionName;

      this.transitionName = transitionName;
      this.showShip = false;
      this.nextShipNumber = shipIndex;
    },
    afterLeave: function afterLeave() {
      this.setCurrentShip({ shipIndex: this.nextShipNumber });
      this.showShip = true;
    },
    enter: function enter() {
      document.getElementById('content-wrapper').scrollTop = 0;
    }
  }),
  components: {
    ShipInformationItem: __WEBPACK_IMPORTED_MODULE_2__components_ShipInformationItem__["a" /* default */]
  }
});

/***/ }),

/***/ "zLeK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/palm-trees@2x.89ba0b6.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ea92f8b33fd808b9a84a.js